import { DOCUMENT } from '@angular/common';
import { effect, inject, signal, Service } from '@angular/core';

type Theme = 'light' | 'dark';

@Service()
export class ThemeService {
  private readonly document = inject(DOCUMENT);
  private readonly currentTheme = signal<Theme>(this.getInitialTheme());

  constructor() {
    effect(() => {
      this.updateBodyClass(this.currentTheme());
    });

    this.listenForThemeChange();
  }

  private getInitialTheme() {
    if (typeof window === 'undefined') {
      return 'light';
    }

    const isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    return isDark ? 'dark' : 'light';
  }

  private listenForThemeChange() {
    if (typeof window === 'undefined') return;

    window
      .matchMedia('(prefers-color-scheme: dark)')
      .addEventListener('change', (e: MediaQueryListEvent) => {
        this.currentTheme.set(e.matches ? 'dark' : 'light');
      });
  }

  private updateBodyClass(theme: Theme) {
    this.document.body.classList.remove('e-theme-light', 'e-theme-dark', 'calcite-mode-dark');
    this.document.body.classList.add(`e-theme-${theme}`);

    if (theme === 'dark') {
      this.document.body.classList.add('calcite-mode-dark');
    }
  }
}
